import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { useList } from "stores/hooks/list";
import Line from "components/layout/line";
import Block from "components/layout/block";
import SettingsForm from "components/list/settings-form";
import ListAdminsTable from "./list-admins-table";
import ObligationForm from "components/list/obligation-form";
import { ListObligation } from "models/list-obligation";
import { adminDoGetListObligation } from "services/admin/list-obligation";
import EmailTemplatesTable from "components/list/email-templates-table";
import { ListEmailTemplate } from "models/list-email-template";
import { adminDoGetListEmailTemplates } from "services/admin/list-email-template";

const BaseTab: FunctionComponent = () => {
  const list = useList();
  const [obligation, toggleObligation] = useState<ListObligation | undefined>(
    undefined,
  );
  const [emailTemplates, toggleEmailTemplate] = useState<ListEmailTemplate[]>(
    [],
  );

  const updateEmailTemplates = async () => {
    if (list) {
      const emailTemplates = await adminDoGetListEmailTemplates(list);
      toggleEmailTemplate(emailTemplates);
    }
  };

  const updateObligation = async () => {
    if (list) {
      const obligation = await adminDoGetListObligation(list);
      toggleObligation(obligation);
    }
  };

  useEffect(() => {
    updateObligation();
    updateEmailTemplates();
  }, [list?.uuid]);

  if (!list) {
    return null;
  }

  return (
    <Fragment>
      <Block title="Perusasetukset">
        <SettingsForm list={list} />
      </Block>
      <Line />

      <Block title="Pääsyoikeudet">
        <ListAdminsTable list={list} />
      </Block>
      <Line />

      {obligation && (
        <Fragment>
          <Block title="Velvoitteet">
            <ObligationForm list={list} obligation={obligation} />
          </Block>
          <Line />
        </Fragment>
      )}

      <Block title="Sähköpostimallit">
        <EmailTemplatesTable
          list={list}
          onUpdate={updateEmailTemplates}
          listEmailTemplates={emailTemplates}
        />
      </Block>
    </Fragment>
  );
};

export default BaseTab;
